
export const name = 'pdfListController';
export default function pdfListController($log, $q, $mdDialog, $window, $scope, errorDialogOpen, pdfListService, chipsService,
                                          analyticsFactory, $translate, fileDownloaderFactory, listManagementFactory, additionalErrorsTranslatorFactory, pusherChannel, $timeout, ecommerceFactory) {
    //noinspection BadExpressionStatementJS
    'ngInject';

    let vm = this;
    vm.deletePdf = deletePdf;
    vm.downloadRequest = downloadRequest;
    vm.share = share;
    vm.getInProcessIcon = getInProcessIcon;
    vm.recomposePendingQuota = recomposePendingQuota;
    vm.getErrorIcon = getErrorIcon;
    vm.getWarningIcon = getWarningIcon;
    vm.getPendingQuotaIcon = getPendingQuotaIcon;
    vm.getErrorInformationIcon = getErrorInformationIcon;
    vm.OnViewErrorDetails = OnViewErrorDetails;
    vm.onStatusFilterChange = onStatusFilterChange;
    vm.onKeyPress = onKeyPress;
    vm.onStatusClick = onStatusClick;
    vm.editTags = editTags;
    vm.increaseRecordsQuota = increaseRecordsQuota;
    vm.isLastUpdateDone = true;
    vm.initializing = true;
    vm.searchText = '';
    vm.statusFilter = 'All';
    vm.all = "All";

    (function activate() {
      analyticsFactory.eventTrack(analyticsFactory.actions.enterPdfListView, analyticsFactory.categories.composer, analyticsFactory.labels.general, null);
      vm.listUtility = listManagementFactory.getMonitoringListService();

      let listInitParams = {
        listName: 'PDFList',
        fetchListByPageFunc: getPdfsByPage,
        getChannelNameFunc: pusherChannel.getChannelName,
        entryUUIDFieldName: "pdfId",
        entryIdentificationFieldName: "pdfId",
        entryNameFieldName: "pdfName",
        listOfDateAttributesToFormat: [],
        placeToAddNewElementToList: listManagementFactory.addNewToBeginningOfList,
        isMultiSelect: true,
        pagination: {
          limit: 20,
          page: 1,
          elementsPerPageOptions: [20, 100, 200]
        },
        events: {
          addedEntry: "PDF_LIST_ENTRY_ADDED",
          deletedEntry: "PDF_LIST_ENTRY_DELETED",
          changedEntry: "PDF_LIST_ENTRY_CHANGED"
        },
        callbacks: {
          onAddedEntry: onPdfAdded,
          onDeletedEntry: null,
          onChangedEntry: onPdfChange,
          onFileSelect: null,
          actionBeforeDeletion: actionBeforeDeletion,
          actionBeforeAddedChanged: actionBeforeAdded,
          actionBeforeChangedOnOldData: actionBeforeChangedOnOldData
        }
      };

      pdfListService.registerOnPdfListRefreshFunction(onPdfListRefreshFunction);

      vm.listUtility.initialize(listInitParams).then(
        function (theList) {
        }, function (status) {
          errorDialogOpen.openErrorDialog(status);
        }
      );
    }());

    function getPdfsByPage(page, pageSize, filter, tag, isInitializing){
      let defer = $q.defer();

      let functionName='pdfListController.getPdfsByPage';
      $log.info(angular.toJson({functionName:functionName, message:'function called', page:page}));

      if(filter !== null) {
        filter = filter.replace(new RegExp(/[\\*^}:"?|<>/]/, 'g'), '');
      }

      vm.initializing = true;
      pdfListService.getPage(page, pageSize, filter, tag, vm.statusFilter).then(function(response){

        response.composedPdfs.forEach(pdf => updateTagsForPdf(pdf));

        if (isInitializing) {
          chipsService.clearChips();
          chipsService.addChips(response.tags);
          vm.listUtility.tags = chipsService.getChips();
        }
        vm.initializing = false;

        let pdfListData = {
          listOfElements: response.composedPdfs,
          totalNumberOfElements: response.totalCount,
          numberOfFilteredElements: response.searchCount
        };

        defer.resolve(pdfListData);
      },function(status){
        vm.initializing = false;
        defer.reject(status);
        errorDialogOpen.openErrorDialog(status);
      });

      return defer.promise;
    }

    vm.statuses = [
      {
        name: pdfListService.statusToStatusForDisplay('completed'),
        value: 'completed'
      },
      {
        name: pdfListService.statusToStatusForDisplay('inProcess'),
        value: 'inProcess'
      },
      {
        name: pdfListService.statusToStatusForDisplay('pending'),
        value: 'pending'
      },
      {
        name: pdfListService.statusToStatusForDisplay('error'),
        value: 'error'
      }
    ];

    let iconsRequire = require.context('@printos/imposer-ui/src/components/templates/images/icons', false, /\.svg/);
    let inProcessIcon = iconsRequire("./processing.svg");
    let errorIcon = iconsRequire("./error.svg");
    let warningIcon = iconsRequire("./warning.svg");
    let errorInformationIcon = iconsRequire("./information.svg");
    let pendingQuotaIcon = iconsRequire("./marketplace.svg");
    vm.pdfIcon = iconsRequire('./pdf.svg');
    vm.timeIcon = iconsRequire('./time.svg');
    vm.clockIcon = iconsRequire('./clock.svg');
    vm.databaseIcon = iconsRequire('./database.svg');
    vm.templateIcon = iconsRequire('./template.svg');

    vm.ecommerceCallback = function(ecommerceData){
      if(vm.isEcommerceEnabled === undefined && ecommerceData.ecommerceEnabled) {
        vm.statuses.push({
          name: pdfListService.statusToStatusForDisplay('pendingQuota'),
          value: 'pendingQuota'
        });
      }
      vm.isEcommerceEnabled = ecommerceData.ecommerceEnabled;
    };

    function editTags($event) {
      if (vm.listUtility.selected.length !== 1) {
        return;
      }
      let pdfToEdit = vm.listUtility.selected[0];

      chipsService.invokeChipsEditor($event, pdfToEdit.tagObjects, pdfToEdit.updateTagsCallback, pdfToEdit);
    }

    function getInProcessIcon(){
        return inProcessIcon;
    }

    function getErrorIcon(){
        return errorIcon;
    }

    function getWarningIcon(){
        return warningIcon;
    }

    function getPendingQuotaIcon(){
        return pendingQuotaIcon;
    }

    function getErrorInformationIcon(){
        return errorInformationIcon;
    }

    function onKeyPress($event){
        if($event && $event.key && $event.key === "Delete"){
            deletePdf(null);
        }
    }

    function onStatusClick(status, $event){
      $event.stopPropagation();
      if(status === 'pendingQuota'){
        //window.location.href = '/market/#/product/composer';
        window.location.href = '/market/#/product/creativity-pack';
      }
    }

    function getPdfFromList(pdfId){
        let listOfPdfs = vm.listUtility.theList.filter(curr => curr.pdfId === pdfId);
        return (!listOfPdfs || listOfPdfs.length === 0) ? null : listOfPdfs[0];
    }

    function deletePdf($event){
        let functionName='pdfListController.deletePdf';
        if(vm.listUtility.selected.length === 0){
            return;
        }

        let pdfsToDelete = vm.listUtility.selected.map(curr => {
          return {
            pdfId: curr.pdfId,
            type: curr.type
          };
        });

        if(pdfsToDelete.length > 0){
          getQuotaRefundRecords().then(numberOfRecords => {
            let firstPdf = null;
            if(pdfsToDelete[0] !== undefined && pdfsToDelete[0] !== null){
              firstPdf = getPdfFromList(pdfsToDelete[0].pdfId);
            }
            $mdDialog.show({
              parent: angular.element(document.body),
              targetEvent: $event,
              clickOutsideToClose: false,
              escapeToClose: true,
              template: require('./delete-dialog/pdfDelete.html'),
              controller: 'pdfDeleteController',
              bindToController: true,
              controllerAs: 'vm',
              locals: {pdfsToDelete:pdfsToDelete, firstPdf:firstPdf, numberOfRecords: numberOfRecords}
            }).then(function (data) {
              $log.info(angular.toJson({action: 'dialog closed successfully', functionName: functionName}));

              if(vm.listUtility.pagination.page === Math.ceil(vm.listUtility.totalNumberOfFilteredElements/vm.listUtility.pagination.limit) && vm.listUtility.selected.length === vm.listUtility.theList.length && vm.listUtility.pagination.page > 1){
                vm.listUtility.pagination.page--;
              }

              analyticsFactory.eventTrack(analyticsFactory.actions.pdfDeletion, analyticsFactory.categories.composer, analyticsFactory.labels.general, null);
            });
          });
        }
    }

    function getQuotaRefundRecords() {
      let functionName = 'getQuotaRefundRecords';
      let defer = $q.defer();
      let numberOfRecords = 0;
      ecommerceFactory.getEcommerceData().then(ecommerceData => {
        let unDownloadedPdfs = vm.listUtility.selected.filter(curr => curr.downloaded === false && curr.status !== 'error' && curr.status !== 'pendingQuota' && curr.status !== 'waiting' && curr.ecommerceLastResetTime >= ecommerceData.lastResetTime);
        let numberOfRecords = 0;
        for (let unDownloadedPdfIndex in unDownloadedPdfs) {
          numberOfRecords += unDownloadedPdfs[unDownloadedPdfIndex].numberOfRecords - unDownloadedPdfs[unDownloadedPdfIndex].failedChunksRecords;
        }
        defer.resolve(numberOfRecords);
      }, (error, status) => {
        $log.log(angular.toJson({
          functionName: functionName,
          action: 'failed to get quota refund records',
          status: status
        }));
        defer.resolve(numberOfRecords);
      });
      return defer.promise;
    }

    function share($event){
      if(vm.listUtility.selected.length === 0){
        return;
      }

      $mdDialog.show({
        parent: angular.element(document.body),
        targetEvent: $event,
        clickOutsideToClose: false,
        escapeToClose: false,
        template: require('./share-dialog/pdfShare.html'),
        controller: 'pdfShareController',
        bindToController: true,
        controllerAs: 'vm',
        locals:{selectedPdfs: vm.listUtility.selected, pdfList: vm.listUtility.theList}
      }).then(function () {
        // $log.info(angular.toJson({action:'dialog closed successfully', functionName:functionName}));
      })
        .catch(function () {
          // $log.info(angular.toJson({action:'dialog failure', functionName:functionName}));

        })
        .finally(function () {
          // isAlreadyOpen = false;
        });
    }

    function downloadRequest($event){
        if(vm.listUtility.selected.length === 0){
            return;
        }

        $mdDialog.show({
            parent: angular.element(document.body),
            targetEvent: $event,
            clickOutsideToClose: false,
            escapeToClose: false,
            template: require('./download-dialog/pdfDownload.html'),
            controller: 'pdfDownloadController',
            bindToController: true,
            controllerAs: 'vm',
            locals:{selectedPdfs: vm.listUtility.selected, pdfList: vm.listUtility.theList}
        }).then(function () {
                // $log.info(angular.toJson({action:'dialog closed successfully', functionName:functionName}));
          })
          .catch(function () {
              // $log.info(angular.toJson({action:'dialog failure', functionName:functionName}));

          })
          .finally(function () {
              // isAlreadyOpen = false;
          });
    }

    function recomposePendingQuota(){
        pdfListService.recomposePendingQuota();
    }

    function OnViewErrorDetails(pdf, $event, $index){
        $event.stopPropagation();
        //toggleSelected($index, null, true);

        let errorContent = [{
            title: $translate.instant('imposer.composer-main.Composer_Template_Name')  + ':',
            body: pdf.templateName,
            shouldTranslate: false
        }];

        if(pdf.dataFileName !== undefined && pdf.dataFileName !== null && pdf.dataFileName !== ""){
            errorContent.push({
                title: $translate.instant('imposer.composer-main.Composer_Data_Name') + ':',
                body: pdf.dataFileName,
                shouldTranslate: false
            });
        }

        if(pdf.csvReportUrl){
          errorContent.push({
            title:$translate.instant('imposer.composer-main.Composer_csv_report'),
            rowType:'csvReport',
            body:pdf.csvReportUrl,
            shouldTranslate:false
          });
        }

        let formattedWarnings = null;
        if(pdf.warnings && pdf.warnings.length > 0) {
          if (pdf.warnings[0].chunkName){
            let chunkIndex = $translate.instant('imposer.composer-main.Chunk_index');
            let chunkName = $translate.instant('imposer.composer-main.Chunk_name');
            formattedWarnings = pdf.warnings.map(warn => {
              if(warn.type && warn.value && warn.value.length > 12 && warn.type.toLowerCase() === 'error'){
                warn.value = "<b>PDF Failed: </b>" + additionalErrorsTranslatorFactory.getAdditionalErrorMessage(warn.value.substring(12, warn.value.length - 1));
              }
              return warn.value + " <b>" + chunkIndex + ":</b> " + warn.chunkIndex + "<br><b>" + chunkName + ":</b> " + warn.chunkName;
            });
          } else {
            formattedWarnings = pdf.warnings.map(warn => warn.value);
          }

          errorContent.push({
              title:$translate.instant('imposer.composer-main.Composer_Error_Details')  + ':',
              rowType:'message',
              body:pdf.engineError,
              additionalBody:formattedWarnings,
              numberOfWarnings:pdf.numberOfWarnings,
              shouldTranslate:false
          });
        }else{
          errorContent.push({
            title:$translate.instant('imposer.composer-main.Composer_Error_Details')  + ':',
            rowType:'message',
            body:pdf.engineError,
            shouldTranslate:false
          });
        }

        $mdDialog.show({
            parent: angular.element(document.body),
            targetEvent: $event,
            clickOutsideToClose: false,
            escapeToClose: true,
            template: require('@printos/imposer-ui/src/components/templates/error-dialog-more-info/errorDialogMoreInfo.html'),
            controller: 'ErrorDialogMoreInfoController',
            bindToController: true,
            controllerAs: 'vm',
            locals:{dialogTitle: pdf.pdfName + ".PDF", errorContent:errorContent}
        })
            .then(function () {
                // $log.info(angular.toJson({action:'dialog closed successfully', functionName:functionName}));
            })
            .catch(function () {
                // $log.info(angular.toJson({action:'dialog failure', functionName:functionName}));

            })
            .finally(function () {
                // isAlreadyOpen = false;
            });
    }

    function onStatusFilterChange(status){
        if(status !== undefined && status !== null){
          vm.listUtility.pagination.page = 1;
          vm.statusFilter = status;
          vm.listUtility.updateSelectedStatus(status);
          vm.listUtility.refreshList();
        }
    }

    function updateTagsCallback(selectedChips) {
      let chipsString = chipsService.convertToChipsString(selectedChips);
      let _this = this;
      let pdfId = _this.pdfId;
      pdfListService.updateTags(pdfId, chipsString).then(
        function (tags) {
          _this.tags = chipsString;
          _this.tagObjects = selectedChips;
          _this.isSelected = true;
          vm.listUtility.tags = angular.copy(chipsService.getChips());

          if (vm.listUtility.selectedTag !== vm.listUtility.all && selectedChips.length === 0) {
            vm.listUtility.theList = vm.listUtility.theList.filter(curr => curr.pdfId !== pdfId);
            vm.listUtility.selected = vm.listUtility.selected.filter(curr => curr.pdfId !== pdfId);

            if (vm.listUtility.tags.indexOf(vm.listUtility.selectedTag) === -1) {
              vm.listUtility.selectedTag = vm.listUtility.all;
              vm.listUtility.refreshList();
            }
          }
        },
        function (error) {
          switch (error) {
            case 406:
              let errorInfo = {
                smsError: {
                  httpStatusCode: 406, subCode: -1, message: "Tag length is restricted to 50 letters"
                }
              };
              errorDialogOpen.openErrorDialog(errorInfo);
              break;
            default:
              errorDialogOpen.openErrorDialog();
              break;
          }
        }
      );
    }

    function updateTagsForPdf(pdf) {
      if ((pdf.tags === undefined) || (pdf.tags === null)) {
        pdf.tags = "";
        pdf.tagObjects = [];
      } else {
        pdf.tagObjects = chipsService.parseChipsListString(pdf.tags);
        if ((pdf.tagObjects === undefined) || (pdf.tagObjects === null)) {
          pdf.tagObjects = [];
        }
      }

      pdf.updateTagsCallback = updateTagsCallback;
    }

    function onPdfListRefreshFunction(){
      vm.listUtility.refreshList();
    }

    function actionBeforeAdded(addedPdf){
      if(Array.isArray(addedPdf)){
        pdfListService.convertField(addedPdf, [pdfListService.populatePdfStatuses, pdfListService.timestampToStringDatetime, pdfListService.calculatTimeTookToComposee]);
      }else{
        pdfListService.convertField([addedPdf], [pdfListService.populatePdfStatuses, pdfListService.timestampToStringDatetime, pdfListService.calculateTimeTookToCompose]);
      }
    }

    function onPdfAdded(addedPdf){
      addedPdf.updateTagsCallback = updateTagsCallback;
      addedPdf.tagObjects = [];
      addedPdf.tags = "";
    }

    function actionBeforeDeletion(pdfsToDelete) {

      pdfsToDelete.forEach(pdf => {
        if (pdf.tagObjects && pdf.tagObjects.length > 0) {
          chipsService.removeChips(pdf.tagObjects);
          let tags = chipsService.getChips();
          vm.listUtility.tags = angular.copy(tags);
        }
      });
    }

    function actionBeforeChangedOnOldData(pdfBeforeChange) {
      if (pdfBeforeChange && pdfBeforeChange.tagObjects && pdfBeforeChange.tagObjects.length > 0) {
        chipsService.removeChips(pdfBeforeChange.tagObjects);
      }
    }

    function onPdfChange(changedEntryData){
      if(Array.isArray(changedEntryData)){
        pdfListService.convertField(changedEntryData, [pdfListService.populatePdfStatuses, pdfListService.timestampToStringDatetime, pdfListService.calculateTimeTookToCompose]);
      }else{
        pdfListService.convertField([changedEntryData], [pdfListService.populatePdfStatuses, pdfListService.timestampToStringDatetime, pdfListService.calculateTimeTookToCompose]);
      }

      changedEntryData.updateTagsCallback = updateTagsCallback;
      changedEntryData.tagObjects = chipsService.parseChipsListString(changedEntryData.tags);
      if ((changedEntryData.tagObjects === undefined) || (changedEntryData.tagObjects === null)) {
        changedEntryData.tagObjects = [];
      } else {
        chipsService.addChips(changedEntryData.tagObjects);
      }
      if(changedEntryData.tagObjects.includes(vm.listUtility.selectedTag) === false && vm.listUtility.selectedTag !== vm.listUtility.all){
        vm.listUtility.removeFromList(changedEntryData);
      }
      vm.listUtility.tags = angular.copy(chipsService.getChips());
    }

    function increaseRecordsQuota() {
      //$window.location = '/market/#/product/composer';
      $window.location = '/market/#/product/creativity-pack';
    }
}
